import ViewScholarshipsReducer from './viewScholarships.reducer';
import ViewNonScholarshipsReducer from './viewNonScholarships.reducer';
import VerifyStudentScholarshipReducer from './verifyStudentScholarship.reducer';
import HallTicketsReducer from './hallTickets.reducer';
import { combineReducers } from 'redux';

const scholarshipsReducer = combineReducers({
  view: ViewScholarshipsReducer,
  verify: VerifyStudentScholarshipReducer,
  nonScholarshipStudents: ViewNonScholarshipsReducer,
  hallTickets: HallTicketsReducer,
});

export { scholarshipsReducer };
